import router from './router'
import store from './store'
// TODO: использовать alias-ы для сокращения пути https://giga.chat/link/gcssnUmNbz
import rootStore from '../../../../../resources/js/store'
import eventBus from './eventBus'

export default {
  router,
  store,
  eventBus,
  managerParamsProvider () {
    const domain = rootStore.state.seo.client.domains.selected

    return domain ? { domain } : null
  }
}
